<template>
  <section id="dashboard-ecommerce">
    <b-row class="match-height">

      <b-col lg="12" md="12">
        <my-results-browser-states :general="data.generalInfo" />
      </b-col>

      <b-col lg="6" md="6">
        <my-results-meetup :data="data.meetup" />
      </b-col>

      <b-col md="6">
        <b-card :title="$t('Minhas posições')">
          <div v-if="loading" class="text-center py-4">
            <b-spinner label="Loading..."></b-spinner>
            <p class="mt-2">{{ $t('Carregando posições...') }}</p>
          </div>
          <div v-else>
            <div v-for="(position, index) in positions" :key="index" class="px-2">
              <div class="d-flex align-items-center mb-1">

                <div class="status-circle mr-2" :class="position.status === 'open' ? 'bg-success' : 'bg-danger'">
                </div>
                <h6 class="mb-0">
                  {{ position.status === 'open' ? $t('Aberta') : $t('Fechada') }}
                </h6>
                <small class="ml-auto text-muted">
                  {{ $t('Criada') }}: {{ formatDate(position.createdAt) }} | {{ $t('Atual') }}: {{
                    formatDate(position.updatedAt) }}
                </small>
              </div>

              <div class="d-flex justify-content-between align-items-center flex-wrap">
                <div class="info-block">
                  <small class="text-muted">{{ $t('Inicial') }}:</small>
                  <p class="mb-0">${{ position.initialLiquidity.toFixed(2) }}</p>
                </div>
                <div class="info-block">
                  <small class="text-muted">{{ $t('Atual') }}:</small>
                  <p class="mb-0">${{ position.currentLiquidity.toFixed(2) }}</p>
                </div>
                <div class="info-block">
                  <small class="text-muted">{{ $t('Variação') }}:</small>
                  <p class="mb-0"
                    :class="{ 'text-success': position.variation > 0, 'text-danger': position.variation < 0 }">
                    ${{ position.variation.toFixed(2) }}
                  </p>
                </div>
                <div class="info-block">
                  <small class="text-muted">{{ $t('Variação (%)') }}:</small>
                  <p class="mb-0"
                    :class="{ 'text-success': position.variationPercentage > 0, 'text-danger': position.variationPercentage < 0 }">
                    {{ position.variationPercentage.toFixed(2) }}%
                  </p>
                </div>
              </div>

              <div v-if="position.status === 'open'" class="text-right mt-2">
                <b-button size="sm" variant="danger" @click="closePosition(index)" :disabled="true">
                  {{ $t('Fechar Posição') }}
                </b-button>
              </div>
              <hr class="my-2" />
            </div>
          </div>
        </b-card>
      </b-col>

    </b-row>

  </section>
</template>

<script>
import { BRow, BCol, BCard, BTable } from "bootstrap-vue";

import MyResultsMedal from "./MyResultsMedal.vue";
import MyResultsStatistics from "./MyResultsStatistics.vue";
import MyResultsMeetup from "./MyResultsMeetup.vue";
import MyResultsBrowserStates from "./MyResultsBrowserStates.vue";
import MyResultsGoalOverview from "./MyResultsGoalOverview.vue";
import IndividuallyTradingCard from "./IndividuallyTradingCard.vue";
import { mapGetters } from "vuex";
import SliderModalMyResults from "./SliderModalMyResults.vue";
import CopyTrades from "../trading-robot/copy-trades/CopyTrades.vue";

export default {
  components: {
    BRow,
    BCol,

    MyResultsMedal,
    MyResultsStatistics,
    MyResultsMeetup,
    MyResultsBrowserStates,
    MyResultsGoalOverview,
    IndividuallyTradingCard,

    SliderModalMyResults,

    CopyTrades,

    BCard,
    BTable
  },
  computed: {
    ...mapGetters(["returnUser"]),
    calcFees() {
      return this.whitdrawValue > 0
        ? this.whitdrawValue <=
          this.modalData.balance -
          this.modalData.initialValue -
          this.modalData.totalWhitdraw -
          this.modalData.valueInFees
          ? 5
          : 60
        : 0;
    },
  },
  data() {
    return {
      showAlert: false,
      textAlert: "",
      colorAlert: "warning",
      data: {},
      modalData: {},
      whitdrawValue: 0,
      percentWithdraw: 0,
      referenceBonus: 0,
      unilevelBonusL2: 0,
      unilevelBonusL3: 0,
      unilevelBonusL4: 0,
      unilevelBonusL5: 0,
      unilevelBonusL6: 0,
      binaryBonus: 0,
      blockedBonus: 0,
      loading: true,
      myRobots: null,
      openModal: false,

      fields: [
        { key: 'createdAt', label: 'Data de Criação', sortable: true },
        { key: 'updatedAt', label: 'Data de Atualização', sortable: true },
        { key: 'status', label: 'Status', sortable: true },
        { key: 'initialLiquidity', label: 'Valor Inicial', sortable: true },
        { key: 'currentLiquidity', label: 'Valor Atual', sortable: true },
        { key: 'variation', label: 'Variação (USDT)', sortable: true },
        { key: 'variationPercentage', label: 'Variação (%)', sortable: true }
      ],
      positions: []
    };
  },
  mounted() {
    this.initialData();
    this.loadMyResults();
  },
  methods: {
    initialData() {
      this.referenceBonus = this.returnUser.referenceBonus
        ? this.returnUser.referenceBonus
        : 0;
      this.unilevelBonusL2 = this.returnUser.unilevelBonusL2
        ? this.returnUser.unilevelBonusL2
        : 0;
      this.unilevelBonusL3 = this.returnUser.unilevelBonusL3
        ? this.returnUser.unilevelBonusL3
        : 0;
      this.unilevelBonusL4 = this.returnUser.unilevelBonusL4
        ? this.returnUser.unilevelBonusL4
        : 0;
      this.unilevelBonusL5 = this.returnUser.unilevelBonusL5
        ? this.returnUser.unilevelBonusL5
        : 0;
      this.binaryBonus = this.returnUser.binaryBonus
        ? this.returnUser.binaryBonus
        : 0;
      this.blockedBonus = this.returnUser.blockedBonus
        ? this.returnUser.blockedBonus
        : 0;
      this.whitdrawValue = 0;
      this.percentWithdraw = 0;
      this.data = {
        generalInfo: null,
        congratulations: {
          name: "",
          patrimony: 0,
        },
        botsRunning: 0,
        statisticsItems: [
          {
            icon: "ActivityIcon",
            color: "light-primary",
            value: 0,
            subtitle: "Trades",
            customClass: "mb-2 mb-xl-0",
          },
          {
            icon: "TrendingUpIcon",
            color: "light-info",
            value: 0,
            subtitle: "Com lucro",
            customClass: "mb-2 mb-xl-0",
          },
          {
            icon: "TrendingDownIcon",
            color: "light-danger",
            value: 0,
            subtitle: "Com prejuízo",
            customClass: "mb-2 mb-sm-0",
          },
          {
            icon: "DollarSignIcon",
            color: "light-success",
            value: 0,
            subtitle: "Resultado",
            customClass: "",
          },
        ],
        meetup: {
          mediaData: [
            {
              avatar: "UserIcon",  // Ícone para representar a comissão vinda das vendas diretas
              title: this.moneyFormat(this.referenceBonus),
              subtitle: "Comissão de Vendas Diretas",  // Mais clara e direta
              color: "success",
            },
            {
              avatar: "UsersIcon",  // Ícone representando o trabalho de equipe ou rede (vendas indiretas)
              title: this.moneyFormat(
                this.unilevelBonusL2 +
                this.unilevelBonusL3 +
                this.unilevelBonusL4 +
                this.unilevelBonusL5
              ),
              subtitle: "Comissão de Vendas Indiretas",  // Padronizado com o anterior
              color: "success",
            },
          ],
        },
        goalOverview: {
          initialValue: 0,
          licenseValue: 0,
          bonus: 0,
          totalProfit: 0,
          progressValue: 0,
          series: [0],
        },
        robots: [],
      };
    },
    loadMyResults() {
      this.data.congratulations.name = this.returnUser.username;
      this.$store.dispatch("dashboardMyResults").then((response) => {
        this.loading = true;
        response.myPositions.map(item => {
          this.positions.push({
            createdAt: item.createdAt,
            updatedAt: item.updatedAt,
            status: item.status,
            initialLiquidity: item.initialLiquidity,
            currentLiquidity: item.currentLiquidity,
            variation: item.currentLiquidity - item.initialLiquidity,
            variationPercentage: ((item.currentLiquidity - item.initialLiquidity) / item.initialLiquidity) * 100
          })

        })

        this.data.generalInfo = response

        this.data.goalOverview.initialValue = response.initialValue
        this.data.goalOverview.licenseValue = response.licenseValue
        this.data.goalOverview.bonus = response.bonus
        this.data.goalOverview.totalProfit = response.totalProfit
        this.data.goalOverview.progressValue = parseFloat((response.bonus / response.limitBonus) * 100).toFixed(2)
        let progressIncome = 0
        response.arrayRobots.map((item) => {
          progressIncome += item.limitIncome > 0 ? parseFloat(item.totalProfit + item.bonus * 0.2) : 0
        })
        this.data.goalOverview.series = [parseFloat((progressIncome / response.limitIncome) * 100).toFixed(2)]
        this.data.statisticsItems[0].value = response.totalTrades;
        this.data.statisticsItems[1].value = response.tradesGain;
        this.data.statisticsItems[2].value = response.tradesLose;
        this.data.statisticsItems[3].value = this.moneyFormat(response.totalProfit);

        this.loading = false;
      });
    },
    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();

      this.handleSubmit();
    },
    openModalMyResults(val) {
      this.modalData = val;
      this.whitdrawValue = 0;
      this.percentWithdraw = 0;
      this.$bvModal.show("modal-my-results");
    },
    closePosition(index) {
      this.positions[index].status = "closed";
      this.positions[index].updatedAt = moment().format("YYYY-MM-DD HH:mm:ss");
      alert(`Posição ${index + 1} foi fechada.`);
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      const options = {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      };
      return date.toLocaleDateString('pt-BR', options).replace(',', ' -');
    }

  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/dashboard-ecommerce.scss";
@import "@core/scss/vue/libs/chart-apex.scss";
@import "@core/scss/vue/libs/vue-slider.scss";

/* Círculo colorido para o status */
.status-circle {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
}

.bg-success {
  background-color: #28a745;
  /* Verde para status "Aberta" */
}

.bg-danger {
  background-color: #dc3545;
  /* Vermelho para status "Fechada" */
}

.info-block {
  margin: 10px 0;
  text-align: center;
}

@media (max-width: 768px) {
  .info-block {
    width: 100%;
  }

  .status-circle {
    margin-right: 10px;
  }

  .text-right {
    text-align: center !important;
  }
}
</style>
